<div class="loader-container"
     *ngIf="loaderVisible$ | async">
  <div class="loader-content">
    <div class="loader-dot"></div>
    <div class="loader-dot"></div>
    <div class="loader-dot"></div>
  </div>
</div>
